import { Diagnosis } from '@/models';
import { GenericService } from './generic.service';

export class PatientReviewDiagnosisService extends GenericService<Diagnosis> {

  constructor(patientId: string, reviewId: string) {
    super(`v1/patients/${patientId}/encounters/${reviewId}/diagnoses`);
  }
}
